import React from "react";
import { useParams, Navigate, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { POLICIES } from "@/lib/policies";
import { VeyroHeader, VeyroFooter } from "@/components/VeyroLayout";
import VeyroCart from "@/components/VeyroCart";

export default function PolicyPage() {
  const { slug } = useParams();
  const policy = POLICIES[slug];

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  if (!policy) return <Navigate to="/" replace />;

  return (
    <div className="min-h-screen bg-[#090A0E]">
      <VeyroHeader />
      <main data-testid={`policy-page-${slug}`} className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-12 py-16 lg:py-24">
        <Link to="/" data-testid="policy-back-link" className="inline-flex items-center gap-2 text-sm font-bold text-[#00E5FF] hover:text-white transition-colors">
          <ArrowLeft size={16} /> Back to store
        </Link>
        <h1 className="mt-6 text-4xl sm:text-5xl font-black tracking-tighter text-white">{policy.title}</h1>
        <div className="mt-10 space-y-10">
          {policy.sections.map((section, i) => (
            <section key={i}>
              {section.heading && <h2 className="text-xl sm:text-2xl font-bold tracking-tight text-white mb-4">{section.heading}</h2>}
              {section.paragraphs?.map((p, j) => (
                <p key={j} className="text-[15px] leading-relaxed text-slate-400 mb-4">{p}</p>
              ))}
              {section.list && (
                <ul className="space-y-3 pl-5 list-disc marker:text-[#00E5FF]">
                  {section.list.map((item, k) => (
                    <li key={k} className="text-[15px] leading-relaxed text-slate-400">{item}</li>
                  ))}
                </ul>
              )}
            </section>
          ))}
        </div>
      </main>
      <VeyroFooter />
      <VeyroCart />
    </div>
  );
}
